module.exports = __webpack_public_path__ + "static/img/1.23b2dfd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wepb/1.webp
// module id = n/YB
// module chunks = 1